import React, { useState, useEffect } from 'react';
import venchiImage from '../../images/questionnaire_doctor.png';
import styles from './venchiMessage.module.css';
import { tWithKeyAttr as t } from "../../i18nHelper";

type Props = {
    message: string | string[];
    size?: 'small' | 'medium' | 'large';
    position?: 'center' | 'topLeft';
    switchIntervalMs?: number;
    typingSpeedMs?: number;
};

const VenchiMessage = ({
    message,
    size = 'medium',
    position = 'center',
    switchIntervalMs = 4000,
    typingSpeedMs = 50,
}: Props) => {
    const [isVisible, setIsVisible] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [typedText, setTypedText] = useState('');

    const imageSize =
        position === 'center'
            ? { small: 70, medium: 130, large: 180 }
            : { small: 40, medium: 60, large: 80 };

    const computedSize = imageSize[size];
    const wrapperClass =
        position === 'center' ? styles.wrapperCenter : styles.wrapperTopLeft;

    const currentMessage = Array.isArray(message) ? message[currentIndex] : message;

    // אפקט להקלדה של הודעה אחת
    useEffect(() => {
        let currentCharIndex = 0;
        setTypedText('');
        const typingInterval = setInterval(() => {
            currentCharIndex++;
            setTypedText(currentMessage.slice(0, currentCharIndex));
            if (currentCharIndex >= currentMessage.length) {
                clearInterval(typingInterval);
            }
        }, typingSpeedMs);

        return () => clearInterval(typingInterval);
    }, [currentMessage, typingSpeedMs]);

    // אפקט להחלפת הודעה רק לאחר שהקלדה הסתיימה
    useEffect(() => {
        if (!Array.isArray(message) || message.length <= 1) return;

        const fullDuration = currentMessage.length * typingSpeedMs + switchIntervalMs;
        const timer = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % message.length);
        }, fullDuration);

        return () => clearTimeout(timer);
    }, [currentMessage, message, switchIntervalMs, typingSpeedMs]);

    return (
        <div className={wrapperClass}>
            <img
                src={venchiImage}
                alt={t('VETZI')}
                className={`${styles.image} ${isVisible ? styles.bounce : ''}`}
                style={{ width: computedSize, height: computedSize }}
                onClick={() => setIsVisible(true)}
            />
            {!isVisible && (
                <div className={styles.messageIcon} aria-label={t('NEW_MESSAGE')}>
                    <span className={styles.swing}>&#128276;</span>
                </div>
            )}
            {position === 'topLeft' ? (
                isVisible && (
                    <div className={styles.bubble}>
                        <button
                            className={styles.closeBtn}
                            onClick={() => setIsVisible(false)}
                            aria-label={t('CLOSE_MESSAGE')}
                        >
                            ×
                        </button>
                        {typedText}
                    </div>
                )
            ) : (
                <div className={styles.bubble}>{typedText}</div>
            )}
        </div>
    );
};

export default VenchiMessage;
